/**
 * @generated SignedSource<<a40cbc80dfec2647cc07fd1ddf753fca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type acceptInvitation_InvitationQuery$variables = {
  token: string;
};
export type acceptInvitation_InvitationQuery$data = {
  readonly Auth: {
    readonly InvitationByToken: {
      readonly accountName: string | null;
      readonly invitingUserName: string | null;
      readonly validUntil: string | null;
    } | null;
  };
};
export type acceptInvitation_InvitationQuery = {
  response: acceptInvitation_InvitationQuery$data;
  variables: acceptInvitation_InvitationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validUntil",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitingUserName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "acceptInvitation_InvitationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthQueries",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Invitation",
            "kind": "LinkedField",
            "name": "InvitationByToken",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "acceptInvitation_InvitationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthQueries",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Invitation",
            "kind": "LinkedField",
            "name": "InvitationByToken",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62a712d9b2b6f539e89850deecc6c3e4",
    "id": null,
    "metadata": {},
    "name": "acceptInvitation_InvitationQuery",
    "operationKind": "query",
    "text": "query acceptInvitation_InvitationQuery(\n  $token: String!\n) {\n  Auth {\n    InvitationByToken(token: $token) {\n      validUntil\n      accountName\n      invitingUserName\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "88f9b0f5f7bac1c1626015fe9e9b7af2";

export default node;
